import React, { Component } from 'react';
import { CircleOutline, CircleBody } from '../../Containers/GymTv/LiveDisplay/Content/style';
import { Text } from '../../UI/Text';
import { NameText, CircleMiddle, CircleTop, CircleBottom } from './style';
import { Icon } from '../Icons/Icons';
import {
    HeartratePercentageIconFactory,
    CaloriesIconFactory,
    HeartrateIconFactory,
} from '../../Containers/GymTv/LiveDisplay/Content/ImagesFactory';
import { truncateLastName, roundNumber } from '../../../Utils';

const getColor = percentage => {
    switch (true) {
        case percentage === null:
            return 'rgba(255, 255, 255, 0.38)';
        case percentage <= 60:
            return 'linear-gradient(to bottom, #a209fe, #2471fe)';
        case percentage <= 70:
            return 'linear-gradient(to top, #25baff, #30fefa)';
        case percentage <= 80:
            return 'linear-gradient(to top, #05d771, #26e410)';
        case percentage <= 90:
            return 'linear-gradient(to bottom, #f8e71d, #fe5013)';
        case percentage <= 100:
            return 'linear-gradient(to bottom, #fb1b1b, #fa7827)';
        default:
            return 'rgba(255, 255, 255, 0.38)';
    }
};

const FINISHED_COLOR = 'rgba(255, 255, 255, 0.38)';

const HeartratePercentage = ({ user: { fullname }, workout: { max_hr_percent } }) => (
    <CircleOutline outline={getColor(max_hr_percent)}>
        <CircleBody>
            <CircleTop>
                <Icon.Box size={'32x24'}>
                    <HeartratePercentageIconFactory percentage={max_hr_percent} />
                </Icon.Box>
            </CircleTop>

            <CircleMiddle>
                <Text fontSize={67} weight={'bold'}>
                    {roundNumber(max_hr_percent, 0)}%
                </Text>
            </CircleMiddle>

            <CircleBottom>
                <NameText>{truncateLastName(fullname)}</NameText>
            </CircleBottom>
        </CircleBody>
    </CircleOutline>
);

const Calories = ({ user: { fullname }, workout: { max_hr_percent, total_calories } }) => (
    <CircleOutline outline={getColor(max_hr_percent)}>
        <CircleBody>
            <CircleTop>
                <Icon.Box size={'24x32'}>
                    <CaloriesIconFactory percentage={max_hr_percent} />
                </Icon.Box>
            </CircleTop>

            <CircleMiddle>
                <Text fontSize={48} weight={'bold'}>
                    {total_calories} cal
                </Text>
            </CircleMiddle>

            <CircleBottom>
                <NameText>{truncateLastName(fullname)}</NameText>
            </CircleBottom>
        </CircleBody>
    </CircleOutline>
);

const Heartrate = ({ user: { fullname }, workout: { max_hr_percent, total_BPM } }) => (
    <CircleOutline outline={getColor(max_hr_percent)}>
        <CircleBody>
            <CircleTop>
                <Icon.Box size={'32x24'}>
                    <HeartrateIconFactory percentage={max_hr_percent} />
                </Icon.Box>
            </CircleTop>

            <CircleMiddle>
                <Text fontSize={48} weight={'bold'}>
                    {total_BPM}
                </Text>
            </CircleMiddle>

            <CircleBottom>
                <NameText>{truncateLastName(fullname)}</NameText>
            </CircleBottom>
        </CircleBody>
    </CircleOutline>
);

const Finished = ({ user: { fullname } }) => (
    <CircleOutline outline={FINISHED_COLOR}>
        <CircleBody>
            <CircleTop>
                <Icon.Box size={'42x42'}>
                    <Icon.Celebrate />
                </Icon.Box>
            </CircleTop>

            <CircleMiddle>
                <Text marginTop={'12px'} fontSize={32} weight={'bold'} opacity={0.8}>
                    Finished!
                </Text>
            </CircleMiddle>

            <CircleBottom>
                <NameText>{truncateLastName(fullname)}</NameText>
            </CircleBottom>
        </CircleBody>
    </CircleOutline>
);

const NoWatch = ({ user: { fullname } }) => (
    <CircleOutline outline={FINISHED_COLOR}>
        <CircleBody>
            <CircleTop>
                <Icon.Box size={'32x32'} opacity={0.27}>
                    <Icon.NoWatch />
                </Icon.Box>
            </CircleTop>

            <CircleMiddle>
                <Text fontSize={67} weight={'bold'}>
                    N/A
                </Text>
            </CircleMiddle>

            <CircleBottom>
                <NameText>{truncateLastName(fullname)}</NameText>
            </CircleBottom>
        </CircleBody>
    </CircleOutline>
);

const JoinCircle = () => (
    <CircleBody dashed={true}>
        <Icon.Box size={'32x32'} opacity={0.27}>
            <Icon.Join />
        </Icon.Box>

        <Text fontSize={50} weight={'bold'} uppercase={true} opacity={0.27}>
            Join
        </Text>

        <Text alignCenter={true} fontSize={21} weight={'bold'} uppercase={true} opacity={0.27}>
            Scan QR below
        </Text>
    </CircleBody>
);

export class GymTvCircle extends Component {
    static HeartratePercentage = HeartratePercentage;
    static Calories = Calories;
    static Heartrate = Heartrate;
    static Finished = Finished;
    static NoWatch = NoWatch;
    static JoinCircle = JoinCircle;

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/GymTvCircle/index.js